import { observer } from 'mobx-react-lite';

import { Modal } from 'semantic-ui-react';
import { useStore } from '../../stores/store';

export default observer(function ModalSmall() {
  const { modalStore } = useStore();

  return (
    <Modal
      open={modalStore.modal.smallOpen}
      onClose={modalStore.closeSmallModal}
      size="tiny"
    >
      <Modal.Content>{modalStore.modal.smallBody}</Modal.Content>
    </Modal>
  );
});
